const IOS_BROWSERS = /CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo|Brave|GSA/i

export function shouldCopyMediaLink() {
  const ua = navigator.userAgent || ''
  if (/Android/i.test(ua)) {
    // WebViews also contain Chrome and Safari tokens; check their markers first.
    if (/\bwv\b|; wv\)|WebView|XWEB_/i.test(ua)) return true
    return !/Chrome\/|Firefox\/|SamsungBrowser\/|VivoBrowser|MiuiBrowser|HuaweiBrowser|EdgA\/|OPR\//i.test(ua)
  }

  const ios = /iPad|iPhone|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
  if (!ios) return false
  // Safari and third-party browser apps identify themselves; a carrier WKWebView
  // normally has neither Safari nor a browser-specific token.
  return !/Safari\//i.test(ua) && !IOS_BROWSERS.test(ua)
}

export function saveMedia(url) {
  if (!url) return Promise.resolve(false)
  let downloadUrl
  try {
    downloadUrl = new URL(url, window.location.href)
  } catch (error) {
    return Promise.resolve(false)
  }
  if (downloadUrl.protocol !== 'http:' && downloadUrl.protocol !== 'https:') return Promise.resolve(false)
  // Existing signed links may be HTTP; the OSS signature does not depend on the scheme.
  downloadUrl.protocol = 'https:'
  window.location.assign(downloadUrl.href)
  return Promise.resolve(true)
}



// WEBPACK FOOTER //
// ./src/utils/mediaDownload.js